var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"outlined":"","flat":""}},[_c('div',{staticClass:"pl-6 pr-6 pb-4 pt-4"},[_c('div',{staticClass:"dash-title dash-single-value-title"},[_vm._v(" "+_vm._s(_vm.dash.title)+" ")]),_c('div',{staticClass:"text-h4 font-weight-bold"},[_c('v-skeleton-loader',{ref:"skeleton",attrs:{"type":"image"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }